import { render } from "./MultiEditPanel.vue?vue&type=template&id=8f1c12b0"
import script from "./MultiEditPanel.vue?vue&type=script&lang=js"
export * from "./MultiEditPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__